module.exports = __webpack_public_path__ + "static/media/wedding03.19961016.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/wedding03.jpg
// module id = 423
// module chunks = 0